/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiTagsIdPathParamsSchema = z.object({
    "Id": z.coerce.number().int().describe("Идентификатор жанра")
    })

/**
 * @description Жанр удален
 */
export const deleteApiTagsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiTagsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiTagsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiTagsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Жанр не найден
 */
export const deleteApiTagsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiTagsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiTagsIdMutationResponseSchema = z.lazy(() => deleteApiTagsId200Schema)